

export default {
	styleOverrides: {
		root: ({ theme }) => ({
			color: (theme.vars || theme).palette.grey[200],
			...theme.applyStyles('dark', {
				color: (theme.vars || theme).palette.grey[100],
			}),
		}),
	},
}
